
import useBooking from '@/composables/useBooking';
import useRuntimeConfig from '@/composables/useRuntimeConfig';
import useTimetable from '@/composables/useTimetable';
import { formatDate, year } from '@/helpers/dateHelper';
import { DirectionEnum } from '@/models/enums';
import { TimetableDeparture } from '@/models/www/TimetableDeparture';
import { useBookingStore } from '@/store/booking';
import { computed, defineComponent, onMounted, watch } from 'vue';
import BaseAlert from '../base/BaseAlert.vue';
import BaseButton from '../base/BaseButton.vue';
import BaseSpinner from '../base/BaseSpinner.vue';
import BaseSvg from '../base/BaseSvg.vue';

export default defineComponent({
	components: { BaseSvg, BaseSpinner, BaseAlert, BaseButton },
	setup() {
		const { departures, loading, params } = useTimetable();
		const bookingStore = useBookingStore();
		const { getRuntimeConfig } = useRuntimeConfig();
		const { cancelActiveBooking } = useBooking();
		
		const title = computed(() => {
			
			return `${formatDate(params.value.date, 'MMMM yyyy', 'Europe/London')} ${params.value.modeOfTravel}`;
			
		});

		onMounted(() => {
			cancelActiveBooking();
		});

		const goToBookingFlow = (departure: TimetableDeparture) => {
			bookingStore.setDate(DirectionEnum.Outward, departure.departureDate);
			bookingStore.setDate(DirectionEnum.Return, departure.departureDate);

			getRuntimeConfig().then((x) => (window.location.href = `${x.bookUrl}?step=1`));
		};

		return { departures, loading, title, params, goToBookingFlow, year };
	}
});
